import apiService from "./../../../../server";
import { ORGANISATION, ORGANISATIONS, ORGANISATION_STATUSES, OWNER_DASHBOARD, SUBSCRIPTION_UPGRADE } from "../api";

export function fetchOwnerDashboard() {
    return apiService.get(OWNER_DASHBOARD);
}

export function fetchOrganisations(page = 0, size = 10) {
    return apiService.get(ORGANISATIONS, { params: { page, size } });
}

export function fetchOrganisationStatuses() {
    return apiService.get(ORGANISATION_STATUSES);
}

export function createOrganisation(data: {
    name: string;
    email: string;
    adminName: string;
    adminEmail: string;
    adminMobileNumber: string;
}) {
    return apiService.post(ORGANISATION, data);
}

export function updateOrganisation(data: {
    orgCode: string;
    status?: string;
    name?: string;
    email?: string;
    active?: boolean;
    subscriptionType?: string;
    maxUsers?: number;
    maxTasks?: number;
    maxNotifications?: number;
    trialEndDate?: string | null;
}) {
    return apiService.put(ORGANISATION, data);
}

export function upgradeSubscription(orgCode: string) {
    return apiService.post(SUBSCRIPTION_UPGRADE, { orgCode });
}
